import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import {
  PhoneNumber,
  PhoneNumberFormat,
  PhoneNumberUtil,
} from 'google-libphonenumber';
import { map, startWith } from 'rxjs/operators';
import { BreakPoints } from '../app.models';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  private env!: string;
  constructor(private _breakpointObserver: BreakpointObserver) {}

  public formatPhoneNumber = (
    phoneNumber: string,
    countryCode?: string
  ): string => {
    const pu = PhoneNumberUtil.getInstance();
    const number = pu.parseAndKeepRawInput(phoneNumber, countryCode);
    const formattedNumber = pu.format(number, PhoneNumberFormat.NATIONAL);
    return formattedNumber;
  };

  public getRawPhoneNumber = (
    phoneNumber: string,
    countryCode?: string
  ): any => {
    const pu = PhoneNumberUtil.getInstance();
    const number: any = pu.parseAndKeepRawInput(phoneNumber, countryCode);
    return number.values_[2];
  };

  public formatToRawPhoneNumber = (phoneNumber: string): string => {
    const number = phoneNumber.replace(/[^+\d]+/g, '');
    return number;
  };

  public isMobile = this._breakpointObserver
    .observe([BreakPoints.XS, BreakPoints.GT_XS])
    .pipe(
      startWith({
        matches: this._breakpointObserver.isMatched([
          BreakPoints.XS,
          BreakPoints.GT_XS,
        ]),
        breakpoints: {
          [BreakPoints.XS]: this._breakpointObserver.isMatched(BreakPoints.XS),
          [BreakPoints.GT_XS]: this._breakpointObserver.isMatched(
            BreakPoints.GT_XS
          ),
        },
      }),
      map((matches: BreakpointState) => matches.breakpoints[BreakPoints.XS])
    );    
}
